import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useDeviceSize } from '@hooks';
import { Typography } from '@elements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CopyComponent = function CopyComponent() {
  var _useDeviceSize = useDeviceSize(),
      mobile = _useDeviceSize.mobile;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    py: 2,
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    children: [/*#__PURE__*/_jsxs(Box, {
      display: "flex",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "body5",
        sx: {
          color: '#999999'
        },
        children: t('components.footer.using')
      }), /*#__PURE__*/_jsxs(Typography, {
        variant: "body5",
        sx: {
          color: '#999999'
        },
        children: ["Copyright \xAE 1999-", new Date().getFullYear(), " ", t('components.footer.officialSite'), " \"", t('components.footer.amurClub'), "\""]
      })]
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "body5",
      sx: {
        color: '#999999'
      },
      mt: mobile ? 2 : 0,
      children: t('components.footer.designAndDevelopment')
    })]
  });
};

export { CopyComponent };